import { Box, IconButton, Typography } from "@mui/material";
import UITooltip from "components/ui/Tooltip/UITooltip";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const SupportContents = ({ supportOptions }) => {
  const theme = useSelector((state) => state?.app?.theme);

  return (
    <Box>
      {supportOptions?.map((comp, ind) =>
        comp?.type === "contact" ? (
          <Box
            key={ind}
            sx={{ marginBottom: "1vw" }}
            className="p-3 px-4 border border-sm rounded-4 contact-support-bcg"
          >
            <Typography className="dashboard-text-lg" sx={{ marginLeft: "-1.2vw" }}>{comp?.title}</Typography>
            <Box className="d-flex gap-3 mt-3">
              {comp?.contents?.map((subItem, subInd) => (
                <Box
                  key={subInd}
                  className={`d-flex gap-1 ${subItem?.value
                      ? "align-items-start"
                      : "flex-row align-items-center"
                    }`}
                  sx={{ minWidth: "12vw" }}
                >
                  <UITooltip title={subItem?.title}>
                    <IconButton
                      sx={{
                        background:
                          theme === "dark"
                            ? "#36357C"
                            : "linear-gradient(90deg, rgba(43, 44, 119, 0.5) 47.31%, rgba(188, 184, 184, 0.5) 129.24%)",
                        padding: "0.8vw",
                        width: "3vw",
                        height: "3vw",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginLeft: "-1.2vw",
                      }}
                      onClick={() => {
                        typeof subItem?.action === "function"
                          ? subItem?.action()
                          : subItem?.iconName === "whatsappIcon"
                            ? window.open(subItem?.action, "_blank")
                            : (window.location.href = subItem?.action);
                      }}
                    >
                      {subItem?.icon}
                    </IconButton>
                  </UITooltip>

                  <Box>
                    <Typography
                      sx={{
                        fontSize: "1vw",
                        fontWeight: 500,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {subItem?.title}
                    </Typography>

                    {subItem?.value && (
                      <Typography sx={{ color: "#9d9cb3", fontSize: "0.9vw" }}>
                        {subItem?.value}
                      </Typography>
                    )}
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        ) : (
          <Box
            key={ind}
            sx={{ marginBottom: "1vw" }}
            className={`d-flex justify-content-between align-items-center p-3 px-4 border border-sm rounded-${comp?.type === "SupportCard" ? "pill" : "4"
              } contact-support-bcg`}
          >
            <Box onClick={comp?.action} style={{ cursor: "pointer" }}>
              <Typography className="dashboard-text-lg">
                {comp?.title}
              </Typography>
              <Typography className="dashboard-text-sm">
                {comp?.message}
              </Typography>
            </Box>
            <Box>
              {
                comp?.type === "SupportCard" ? (
                  <UITooltip title={comp?.title}>
                    <IconButton
                      sx={{
                        background:
                          theme === "dark"
                            ? "#36357C"
                            : "linear-gradient(90deg, rgba(43, 44, 119, 0.5) 47.31%, rgba(188, 184, 184, 0.5) 129.24%)",
                        padding: "0.8vw",
                        width: "3vw",
                        height: "3vw",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginLeft: "-0.3vw",
                      }}
                      onClick={() => {
                        typeof comp?.action === "function"
                          ? comp?.action()
                          : comp?.iconName === "whatsappIcon"
                            ? window.open(comp?.action, "_blank")
                            : (window.location.href = comp?.action);
                      }}
                    >
                      {comp?.icon}
                    </IconButton>
                  </UITooltip>
                ) : (
                  <UITooltip title={comp?.title}>
                    <img
                      src={comp?.image}
                      alt="Loading..."
                      width="100%"
                      onClick={comp?.action}
                      style={{ cursor: "pointer" }}
                    />
                  </UITooltip>
                )
              }
            </Box>
          </Box>
        )
      )}
    </Box>
  );
};

export default SupportContents;
